document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href$="#vertrag-widerrufen"]');
  if (!link || link.origin !== window.location.origin) return;
  const section = document.getElementById('vertrag-widerrufen');
  if (!section) return;
  const trigger = section.querySelector('[data-hb-widerruf-trigger], [data-hb_widerruf-trigger], .hb-widerruf-button');
  if (!trigger) return;
  event.preventDefault();
  link.focus({ preventScroll: true });
  trigger.click();
});
